import { defineStore } from 'pinia';

// 這邊 defineStore 會自動動態註冊模組，回傳值為 hook function
export const useMainStore = defineStore('Main', {
  // 注意 state 是一個 function，推薦使用 arrow function
  // 可幫助 typescript 更好進行類型推斷
  state: () => ({
    isLoading: true,
    isMobile: null,
    popup: null,
    popupQueue: null,
    testValue: 111,
  }),
  getters: {},
  actions: {
    setLoading(boolean) {
      this.$patch((state) => {
        state.isLoading = boolean;
      });
    },
    setIsMobile(boolean) {
      this.$patch((state) => {
        state.isMobile = boolean;
      });
    },
    openPopup(sting) {
      this.$patch((state) => {
        state.popup = sting;
      });
    },
    closePopup() {
      this.$patch((state) => {
        state.popup = null;
      });
    },
  },
});
